const featureItems = [
  {
    icon: 'ri-skip-forward-mini-line',
    title: '极速播放引擎',
    desc: '自研视频加速技术，首帧加载快至1.2秒，拖动进度条零等待，告别缓冲焦虑。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全终端适配',
    desc: '电脑、平板、手机全兼容，自适应布局与触控优化，随时随地无缝切换观影设备。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净无广告',
    desc: '播放全程无弹窗、无贴片、无强制跳转，专注内容本身，给你最干净的观影环境。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量片库',
    desc: '10万+资源覆盖全球电影电视剧，每日200+更新入库，从热门到冷门一应俱全。',
  },
  {
    icon: 'ri-live-line',
    title: '多线路智能切换',
    desc: '每部影片配备3-6条播放线路，智能检测最优节点，卡顿时一键秒切其他线路。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="bg-background-50 py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap mb-3">
            平台优势
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="text-foreground-600 text-sm mt-2">为什么千万用户选择7777影院？五大核心优势给你答案</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featureItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70 text-center group hover:border-primary-200 cursor-pointer transition-colors"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 mx-auto mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-600 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}